import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "@/lib/sentry";
import { initClarity } from "@/lib/clarity";

if (typeof window !== "undefined") {
  try {
    void initSentry();
  } catch (error) {
    console.warn("Failed to load Sentry", error);
  }

  const loadClarity = () => {
    try {
      initClarity();
    } catch (error) {
      console.warn("Failed to load Clarity", error);
    }
  };

  const maybeRequestIdle = (window as typeof window & {
    requestIdleCallback?: (callback: IdleRequestCallback) => number;
  }).requestIdleCallback;

  if (typeof maybeRequestIdle === "function") {
    maybeRequestIdle(loadClarity);
  } else {
    window.setTimeout(loadClarity, 2000);
  }
}

createRoot(document.getElementById("root")!).render(<App />);
